// src/components/CalculateMoney/AssignmentPanel.jsx
import React, { useState } from 'react';
import { List, Box, Chip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useTranslation } from 'react-i18next';

import {
  StaffListOuterContainer,
  AssignmentPanelTitleBox,
  AssignmentPanelTitle,
  searchBarBox,
  noStaffText,
  staffPrimaryText,
  staffEmailText,
  staffPhoneText,
} from '../../styles/CalculateMoney/AssignmentPanelStyles';
import {
  StyledListItem,
  StyledListItemText,
  StyledTypography,
  StyledIconButton
} from '../../styles/OwnerStyle/StaffComPonent/StaffListStyles';
import AssignCustomerModal from './AssignCustomerModal';
import SearchBar from '../ownerDashboard/SearchBarContainer';


const AssignmentPanel = ({ staff, businessId, onShowSuccess, workSessions }) => {
  const { t } = useTranslation('assignmentPanel');
  const [openModal, setOpenModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleOpenModal = (staff) => {
    setSelectedStaff(staff);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedStaff(null);
  };

  const filteredStaff = staff?.filter(s =>
    s.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
  ) || [];

  const getInProgressCount = (staffId) => {
    let arr = workSessions;
    if (arr && arr.$values) arr = arr.$values;
    if (!Array.isArray(arr)) arr = [];
    return arr.filter(
      ws =>
        Number(ws.staffId) === Number(staffId) &&
        ws.status?.toLowerCase() === "in progress"
    ).length;
  };

  const getInProgressSessionsForStaff = (staffId) => {
    let arr = workSessions;
    if (arr && arr.$values) arr = arr.$values;
    if (!Array.isArray(arr)) arr = [];
    return arr.filter(
      ws =>
        Number(ws.staffId) === Number(staffId) &&
        ws.status?.toLowerCase() === "in progress"
    );
  };

  return (
    <Box>
      <AssignmentPanelTitleBox>
        <AssignmentPanelTitle>
          {t('title')}
        </AssignmentPanelTitle>
      </AssignmentPanelTitleBox>

      <Box sx={searchBarBox}>
        <SearchBar
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder={t('searchPlaceholder')}
        />
      </Box>

      <StaffListOuterContainer>
        <List dense>
          {filteredStaff.length === 0 && (
            <Box sx={noStaffText}>
              {t('noStaffFound')}
            </Box>
          )}
          {filteredStaff.map((s) => {
            const inProgressCount = getInProgressCount(s.staffId);
            return (
              <StyledListItem key={s.staffId}>
                <StyledListItemText
                  primary={
                    <StyledTypography variant="body1" sx={staffPrimaryText}>
                      {s.name}
                      {inProgressCount > 0 && (
                        <Chip
                          size="small"
                          label={t('inProgressCount', { count: inProgressCount })}
                          color="warning"
                          sx={{
                            ml: 2,
                            fontWeight: 400,
                            fontSize: { xs: '0.5em', md: '0.75em' },
                            verticalAlign: 'top'
                          }}
                        />
                      )}
                    </StyledTypography>
                  }
                  secondary={
                    <>
                      <span style={staffEmailText}>{s.email}</span>
                      <br />
                      <span style={staffPhoneText}>{s.phone}</span>
                    </>
                  }
                />
                <StyledIconButton
                  edge="end"
                  color="primary"
                  aria-label="add-customer"
                  onClick={() => handleOpenModal(s)}
                >
                  <AddCircleOutlineIcon />
                </StyledIconButton>
              </StyledListItem>
            );
          })}
        </List>
      </StaffListOuterContainer>

      {selectedStaff && (
        <AssignCustomerModal
          open={openModal}
          onClose={handleCloseModal}
          staff={selectedStaff}
          businessId={businessId}
          onShowSuccess={onShowSuccess}
          inProgressSessions={getInProgressSessionsForStaff(selectedStaff.staffId)}
          staffList={staff}
        />
      )}
    </Box>
  );
};

export default AssignmentPanel;
